import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { injectStore } from 'services/APIHttpClient'
import { AsyncModalProvider } from 'components/modal/AsyncModalContext'
import AppErrorFallback from 'components/AppErrorFallback'
import reportWebVitals from './reportWebVitals'
import { store } from './store/Store'

import App from './App'

injectStore(store)

const root = createRoot(document.getElementById('root'))

const basename = process.env.REACT_APP_WEB_BASE_PATH
root.render(
  <AsyncModalProvider>
    <Provider store={store}>
      <BrowserRouter basename={basename}>
        <AppErrorFallback>
          <App />
        </AppErrorFallback>
      </BrowserRouter>
    </Provider>
  </AsyncModalProvider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
